<template lang="pug">
  .dashboard-view
    v-container.pa-0(style="max-width:600px" )
      agent-commission-chart(:company="company" :agent="agentData" @bank="openBankDialog = $event" @spanChange="handleChangeSpan")
      div.mt-4.px-4
        div.h6.mb-1 {{ $t('commission_list') }}
        div.primary400--text.label.text-uppercase.mb-2 {{ spanTitle }}
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(indeterminate color="primary" :width="2" :size="50")
      template(v-else)
        template(v-if="commissions.length === 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(contain style="width:60px; height:60px" :src="require('@/assets/images/icon_empty.png')")
              p.c1 {{ $t('no_item_found') }}
        template(v-else v-for="(commission, index) in commissions")
          div.list-item.px-4.py-2(flat :key="index" :class="commissions.length !== index + 1 || 'list-item-bottom'")
            v-row(no-gutters align="center")
              v-col
                div.font-weight-bold.s2.basic1000--text(@click="clickOpenReceipt(commission.lead)") {{ commission.created | convertServerDateWithZone }}
                //- v-col
                  div.font-weight-bold.s2.basic1000--text Amount: {{ commission.amount | displayPrice }}
            v-row(no-gutters)
              v-col(cols="8")
                div.c1.basic600--text {{ $t('name') }}: {{ commission.lead.name }}
                div.c1.basic600--text {{ $t('phone') }}: {{ commission.lead.phone | phoneFormat }}
              v-col
                div.c1.basic600--text {{ $t('amount') }}: {{ commission.amount | displayPrice }}
        div.mb-6
          y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
      
    .modal
      add-agent-bank-account(v-if="openBankDialog" :open.sync="openBankDialog" :company="company" :agent="agentData" @refresh="fetchAgentData")
      product-invoice(v-if="openInvoiceDialog" :open.sync="openInvoiceDialog" :parentLead.sync="lead")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AgentCommissionChart from '@/components/analytics/AgentCommissionChart.vue'
import AddAgentBankAccount from '@/components/dialogs/AddAgentBankAccount.vue'
import ProductInvoice from '@/components/dialogs/database/ProductInvoice.vue'

export default {
  name: 'Commissions',
  components: { AgentCommissionChart, AddAgentBankAccount, ProductInvoice },
  props: ['company', 'menu'],
  data: () => ({
    isFetching: false,
    page: 1,
    pageSize: 15,
    count: 0,
    agentData: null,
    commissions: [],
    openBankDialog: false,
    openInvoiceDialog: false,
    lead: null,
    customDateFilterRange: [],
    selectedSpan: 'week',
    customDateFilterRangeFormatted: 'Date Range',
  }),
  computed: {
    ...mapState('user', ['member']),
    spanTitle () {
      if (this.selectedSpan === 'custom') {
        return this.customDateFilterRangeFormatted
      } else if (this.selectedSpan === 'day') {
        return 'Today'
      }
      return 'this ' + this.selectedSpan
    }
  },
  watch: {
    page () {
      this.fetchCommission(this.selectedSpan)
    },
  },
  mounted () {
    this.fetchAgentData()
    this.fetchCommission(this.selectedSpan)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleChangeSpan (data) {
      this.selectedSpan = data.range.id
      this.customDateFilterRange = data.selectedDateRange
      this.customDateFilterRangeFormatted = this.formatDateRange(data.selectedDateRange)
      this.fetchCommission()
    },
    fetchAgentData () {
      this.$axios.get('/agent/agents/', { params: { member__company: this.company.id }})
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.agentData = resp.data.results[0]
          }
        })
    },
    fetchCommission () {
      this.isFetching = true
      let params = {}
      if (this.company.id == this.$store.state.constants.AC_COMPANY_ID) {
        if (this.selectedSpan === 'custom') {
          params = {
            member__company: this.company.id,
            member: this.member.id,
            span: 'custom',
            from: this.customDateFilterRange[0],
            until: this.customDateFilterRange[1],
            page: this.page,
            page_size: this.pageSize
          }
        } else {
          params = {
            member__company: this.company.id,
            member: this.member.id,
            span: this.selectedSpan,
            page: this.page,
            page_size: this.pageSize
          }
        }
        this.$axios.get('/agent/commissions/', { params })
          .then(resp => {
            this.commissions = resp.data.results
            this.count = resp.data.count
          })
          .finally(() => {
            this.isFetching = false
          })
      } else {
        if (this.selectedSpan === 'custom') {
          params = {
            company: this.company.id,
            page: this.page,
            page_size: this.pageSize,
            created_after: this.customDateFilterRange[0],
            created_before: this.customDateFilterRange[1]
          }
        } else {
          params = {
            company: this.company.id,
            range: this.selectedSpan,
            page: this.page,
            page_size: this.pageSize
          }
        }
        this.$axios.get('/members/commissions/', { params })
          .then(resp => {
            this.commissions = resp.data.results
            this.count = resp.data.count
          })
          .finally(() => {
            this.isFetching = false
          })
      }
    },
    clickOpenReceipt(lead) {
      this.$axios.get(`/leads/${lead.pid}/`)
        .then((resp) => {
          this.lead = resp.data
          this.openInvoiceDialog = true
        })
        .catch(() => {})
    },
    formatDateRange (range) {
      if (range.length === 0) {
        return 'Date Range'
      } else if (range.length === 1) {
        const [year, month, day] = range[0].split('-')
        return `${day}/${month}/${year} -`
      } else {
        const [year1, month1, day1] = range[0].split('-')
        const [year2, month2, day2] = range[1].split('-')
        return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`
      }
    },
  }
}
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.v-picker__title {
  height: 0;
  padding: 0;
}
.list-item{
border:1px solid var(--v-primary100);
border-radius: 0;
border-top:4px solid var(--v-primary200);
}
.list-item-bottom{
  border-bottom:4px solid var(--v-primary200);
}
</style>

<style lang="scss">
</style>